import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
// import { Checkbox } from "../../../../components/ui/checkbox";
import { Input } from "../../../../components/ui-comp/input";
import { cn } from "../../../../lib/utils";
import { z } from "zod";
import { Button } from "../../../../components/ui/button";
// import { Textarea } from "../../../../components/ui-comp/textarea";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { createCredential } from "../../../../helpers/mutations/credentials";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../components/ui/select";
import { FaPlus } from "react-icons/fa6";

const AddCredentialModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: createCredential,
    onSuccess: (data) => {
      handleClose();
      queryClient.invalidateQueries({
        queryKey: ["credentials"],
      });
      toast("Successful");
    },
    onError: (data) => {
      toast(data.message);
    },
  });

  // Define form validation schema
  const formSchema = z.object({
    name: z.string().min(3, "A Name is required"),
    credential_type: z.string().min(2, "Credential type is required"),
    username: z.string().nullable(),
    password: z.string().nullable(),
    sshusername: z.string().nullable(),
    private_key: z.instanceof(File).nullable().or(z.string().nullable()),
    passphrase: z.string().nullable(),
    ssh_port: z.string().nullable().default("22"),
  });

  // const [fileName, setFileName] = React.useState(null);
  // console.log("fileName", fileName);

  // Initialize form
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    // reset
  } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: null,
      credential_type: null,
      username: null,
      password: null,
      sshusername: null,
      private_key: null,
      passphrase: null,
      ssh_port: null,
    },
  });

  const onSubmit = (data) => {
    mutate(data);
  };

  // Add state to track credential type
  const [credentialType, setCredentialType] = useState("");

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button className="w-fit px-2 rounded-lg">
          <FaPlus size={16} />
          <span className="font-medium pr-2">Add new credential</span>
        </Button>
      </DialogTrigger>
      <DialogContent className="">
        <DialogHeader className="text-left">
          <DialogTitle className="text-md text-semibold text-black">
            Add New Credential
          </DialogTitle>
          <DialogDescription>
            Create a credential for in-depth scans.
          </DialogDescription>
        </DialogHeader>

        <hr />
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div className="">
            <Input
              label="Name"
              name="name"
              type="text"
              {...register("name")}
              placeholder="Enter unique name"
              className={cn(
                errors.name &&
                  "border-[#e84539] focus-visible:ring-[#ec5247] ring:ring-[#FEE4E2]",
                "text-black"
              )}
            />
            {errors.name && (
              <p className="text-red-500 text-sm mb-4">{errors.name.message}</p>
            )}
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="description"
              className="text-sm  font-medium text-gray-700"
            >
              Credential type
            </label>

            <Select
              onValueChange={(val) => {
                setValue("credential_type", val);
                setCredentialType(val);
              }}
              value={credentialType} // keep it controlled
            >
              <SelectTrigger>
                <SelectValue placeholder="Select a credential type" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="up">Username and password</SelectItem>
                <SelectItem value="ssh">Username and SSH Key</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div
            id="username_password"
            className={credentialType === "up" ? "w-full" : "hidden w-full"}
          >
            <div className="">
              <Input
                label="Username"
                name="username"
                type="text"
                {...register("username")}
                placeholder="Enter username"
                className={cn(
                  errors.username &&
                    "border-[#e84539] focus-visible:ring-[#ec5247] ring:ring-[#FEE4E2]",
                  "text-black"
                )}
              />
              {errors.username && (
                <p className="text-red-500 text-sm mb-4">
                  {errors.username.message}
                </p>
              )}
            </div>

            <div className="">
              <Input
                label="Password"
                name="password"
                {...register("password")}
                type="password"
                placeholder="Enter password"
                className={cn(
                  errors.name &&
                    "border-[#e84539] focus-visible:ring-[#ec5247] ring:ring-[#FEE4E2]",
                  "text-black"
                )}
              />
              {errors.name && (
                <p className="text-red-500 text-sm mb-4">
                  {errors.username.message}
                </p>
              )}
            </div>
          </div>

          <div
            id="ssh"
            className={credentialType === "ssh" ? "w-full" : "hidden w-full"}
          >
            <div className="">
              <Input
                label="Username"
                name="sshusername"
                {...register("sshusername")}
                type="text"
                placeholder="Enter username"
                className={cn(
                  errors.sshusername &&
                    "border-[#e84539] focus-visible:ring-[#ec5247] ring:ring-[#FEE4E2]",
                  "text-black"
                )}
              />
              {errors.sshusername && (
                <p className="text-red-500 text-sm mb-4">
                  {errors.sshusername.message}
                </p>
              )}
            </div>

            <div className="">
              <input
                className="flex h-11 mb-4 w-full rounded-[8px] border border-input bg-background px-3 py-2 text-base ring-offset-[#EFF8FF] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#101928] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                label="Key file"
                name="private_key"
                // {...register("private_key")}
                type="file"
                accept=".pem,.key,.txt,.ppk"
                placeholder="Upload private key"
                onChange={(e) => {
                  // console.log(e.target.files);
                  // if (e.target.files?.[0]) {
                  //   console.log("Selected file:", e.target.files[0].name);
                  // }

                  const file = e.target.files?.[0];
                  if (file) {
                    // console.log("Selected file:", e.target.files[0].name);

                    setValue("private_key", file);
                    // setFileName(file.name);
                  } else {
                    console.log("no file selected");
                  }
                }}
              />
              {errors.private_key && (
                <p className="text-red-500 text-sm mb-4">
                  {errors.private_key.message}
                </p>
              )}
            </div>

            <div className="">
              <Input
                label="Passphrase"
                name="passphrase"
                {...register("passphrase")}
                type="password"
                placeholder="Enter passphrase - leave empty if none"
                className={cn(
                  errors.passphrase &&
                    "border-[#e84539] focus-visible:ring-[#ec5247] ring:ring-[#FEE4E2]",
                  "text-black"
                )}
              />

              <div className="">
                <Input
                  label="Port"
                  name="ssh_port"
                  {...register("ssh_port")}
                  type="text"
                  placeholder="Enter port"
                  className={cn(
                    errors.ssh_port &&
                      "border-[#e84539] focus-visible:ring-[#ec5247] ring:ring-[#FEE4E2]",
                    "text-black"
                  )}
                />
                {errors.ssh_port && (
                  <p className="text-red-500 text-sm mb-4">
                    {errors.ssh_port.message}
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="flex justify-end space-x-4 pt-4">
            <Button type="submit" className="px-4 " loading={isPending}>
              Create
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddCredentialModal;
